module.exports = __webpack_public_path__ + "static/img/grade_6.c15ab41.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_6.png
// module id = EYio
// module chunks = 89